import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body, button {
    background: #ffff;
    font-family: 'Times New Roman', Times, serif;
  }

  #app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    max-width: 1600px;
    margin: 0 auto;

    &.full-width {
      max-width: 100%;
    }
  }

  @media print {
    .download-button {
      display: none;
    }
  }
`;
